(function() {
	'use strict';

	angular.module('app.leanProjects')
		.service('goalPerformanceService', goalPerformanceService);
	
	goalPerformanceService.$inject = ['$http', 'URLS', 'leanFilterService'];
	function goalPerformanceService($http, URLS, leanFilterService) {
		return {
			getData: getData
		};

		function getData() {
			var pageUrl;
			pageUrl = buildUrl();
			return $http.get(URLS.host + pageUrl).then(function(result) {
				return result.data;
			});
		}

		function buildUrl() {
			var factories = leanFilterService.getFactoryList();
			return URLS.prefix + factories + '/LeanProject/GoalPerformance';
		}
	}
})();
